import React, { PropsWithChildren, useContext } from 'react';

interface SidebarContextValue {
  sidebarExpanded: boolean;
  expandedItems: string[];
  setItemExpanded: (id: string) => void;
  toggleItemExpanded: (id: string) => void;
  onLinkClick: () => void;
}

const SidebarContext = React.createContext<SidebarContextValue>({
  sidebarExpanded: true,
  expandedItems: [],
  setItemExpanded: () => {},
  toggleItemExpanded: () => {},
  onLinkClick: () => {},
});

export const SidebarContextProvider: React.FC<PropsWithChildren<SidebarContextValue>> = ({ children, ...value }) => {
  return <SidebarContext.Provider value={value}>{children}</SidebarContext.Provider>;
};

export const useSidebarContext = (): SidebarContextValue => {
  return useContext(SidebarContext);
};
